// 引入工具函数
import req from '@/utils/request';

export const getDialogList = (params) => {
  return req.post('/wechat/picture/window/page', params);
}
export const addDialog = (params) => {
  return req.post('/wechat/picture/window', params);
}
export const editDialog = (params) => {
  return req.put('/wechat/picture/window', params);
}
export const getDialog = (params) => {
  return req.get('/wechat/picture/window/get', params);
}
export const deleteDialog = (params) => {
  return req.delete(`/wechat/picture/window?ids=${params}`);
}
export const getDynamicList = (params) => {
  return req.post(`/wechat/dynamic-page/page`,params);
}
export const addDynamic = (params) => {
  return req.post(`/wechat/dynamic-page`,params);
}
export const editDynamic = (params) => {
  return req.put(`/wechat/dynamic-page`,params);
}
export const getDynamic = (params) => {
  return req.get(`/wechat/dynamic-page/get`,params);
}
export const deleteDynamic = (params) => {
  return req.delete(`/wechat/dynamic-page?ids=${params}`);
}
export const getQrcode = (params) => {
  return req.get(`/wechat/dynamic-page/qrcode`,params);
}
export const getDynamicClickList = (params) => {
  return req.post(`/wechat/dynamic-page/click/page`,params);
}
// 查询优惠券类型列表
export const getCouponList = (params) => {
  return req.get(`/coupon/type/list`,params);
}